import ExampleFeatureView from './views/ExampleFeatureView.vue';
import DocMasterView from './views/DocMasterView.vue';
import DocMasterViewAdvisor from './views/DocMasterViewAdvisor.vue';
import DocMasterGridView from './views/DocMasterGridView.vue';
import DocInspectorView from '@frontend/ui/features/docmaster/views/DocInspectorView.vue';
import NoteTaking from './views/NoteTaking.vue';
import UpcomingMeetings from './views/UpcomingMeetings.vue';
import EntityDetail from './views/EntityDetail.vue';
import DossierDiff from './views/DossierDiff.vue';
import CRMMigrationProposal from './views/CRMMigrationProposal.vue';
import CRMMigrationResults from './views/CRMMigrationResults.vue';
import MeetingPrep from './views/MeetingPrep.vue';
import FormUploadView from './views/FormUploadView.vue';
import FactSheetView from '@frontend/ui/views/entity/FactSheetView.vue';
import EntityReports from './views/EntityReports.vue';
import SummaryView from './views/SummaryView.vue';
import Dossier from './views/Dossier.vue';
import EntityHoldings from './views/EntityHoldings.vue';
import EntityPermissions from './views/EntityPermissions.vue';
import EntityRecommendations from './views/EntityRecommendations.vue';
import PermissionsGroups from './views/PermissionsGroups.vue';
import EntityPlanning from './views/planning/EntityPlanning.vue';
import EntitySimpleNotes from '@features/notes/views/EntitySimpleNotes.vue';
import EntityCases from './views/EntityCases.vue';

const routes = [
  {
    name: "entity-detail",
    path: "/advisor/entity/:entityExternalId",
    component: EntityDetail,
    props: (route) => ({
      entityExternalId: route.params.entityExternalId,
      meetingId: route.query.meetingId,
    }),
    children: [
      {
        name: "entity-summary",
        path: "/advisor/entity/:entityExternalId/summary",
        component: SummaryView,
      },
      {
        name: "entity-dossier",
        path: "dossier",
        component: Dossier,
      },
      {
        name: "entity-portfolio",
        path: "portfolio",
        component: EntityHoldings,
      },
      {
        name: "entity-reports",
        path: "reports",
        component: EntityReports,
      },
      {
        name: "entity-documents",
        path: "documents",
        component: DocMasterViewAdvisor,
      },
      {
        name: "entity-note-taking",
        path: "note-taking",
        component: NoteTaking,
        props: (route) => ({
          entityExternalId: route.params.entityExternalId,
          meetingIdQueryParam: route.query.meetingId,
        }),
      },
      {
        name: "entity-recommendations",
        path: "recommendations",
        component: EntityRecommendations,
      },
      {
        name: "entity-simple-notes",
        path: "notes",
        component: EntitySimpleNotes,
      },
      {
        name: "entity-groups",
        path: "groups",
        component: PermissionsGroups,
      },
      {
        name: "entity-cases",
        path: "cases",
        component: EntityCases,
      },
      {
        name: "entity-planning",
        path: "planning",
        component: EntityPlanning,
      },
      {
        name: "entity-permissions",
        path: "permissions",
        component: EntityPermissions,
      },
    ],
  },
  {
    name: "fact-sheet",
    path: "/advisor/entity/:entityExternalId/fact-sheet",
    component: FactSheetView,
    props: (route) => ({
      entityExternalId: route.params.entityExternalId,
    }),
  },
  {
    name: "upcoming-meetings",
    path: "/advisor/upcoming-meetings/:prospectId",
    component: UpcomingMeetings,
  },
  {
    name: "note-taking",
    path: "/advisor/note-taking/:meetingId",
    component: NoteTaking,
    props: (route) => ({ prospectId: route.query.prospectId }),
  },
  {
    name: "meeting-prep",
    path: "/advisor/meeting-prep/:prospectId",
    component: MeetingPrep,
    props: (route) => ({ prospectId: route.params.prospectId }),
  },
  {
    name: "documents",
    path: "/advisor/entity/:entityExternalId",
    component: EntityDetail,
    props: (route) => ({
      entityExternalId: route.params.entityExternalId,
      activeTab: route.query.activeTab || "documents",
      meetingId: route.query.meetingId,
    }),
  },
  {
    name: "reconciliation",
    path: "/advisor/entity/:entityExternalId/reconciliation",
    component: DossierDiff,
    props: (route) => ({
      entityExternalId: route.params.entityExternalId,
    }),
  },
  {
    name: "crm-migration",
    path: "/advisor/entity/:entityExternalId/crm-migration",
    component: CRMMigrationProposal,
    props: (route) => ({
      entityExternalId: route.params.entityExternalId,
      crmType: route.query.crm_type || 'salesforce',
    }),
  },
  {
    name: "crm-migration-results",
    path: "/advisor/entity/:entityExternalId/crm-migration-results/:migrationId",
    component: CRMMigrationResults,
    props: (route) => ({
      entityExternalId: route.params.entityExternalId,
      migrationId: route.params.migrationId,
      crmType: route.query.crm_type || 'salesforce',
    }),
  },
  {
    name: "documents",
    path: "/advisor/entity/:entityId",
    component: DocMasterViewAdvisor,
    props: (route) => ({
      entityExternalId: route.params.entityId,
    }),
  },
  {
    name: 'document-inspector',
    path: '/advisor/document-inspector/:id',
    component: DocInspectorView,
    props: route => ({
      id: route.params.id,
      entityId: route.query.entityId,
    }),
  },
  {
    name: "example-feature",
    path: "/advisor/example",
    component: ExampleFeatureView,
  },
  {
    name: "docmaster",
    path: "/advisor/docmaster",
    component: DocMasterView,
  },
  {
    name: "form-upload",
    path: "/advisor/form-upload",
    component: FormUploadView,
  },
];

export default routes;
